import React from "react";

function OperatingModel() {
  const principles = [
    {
      title: "Repeatability through GenAI",
      description: "Our digital coworkers handle tasks like data prep, campaign ops, and QA - so human teams can focus on value."
    },
    {
      title: "Lean, senior, outcome-led teams",
      description: "We deploy smaller, expert-led squads with the right mix of business, data, and tech skills."
    },
    {
      title: "Embedded from Day 1",
      description: "We work inside your cloud, tools, and workflows - aligning with your teams to build lasting capability."
    }
  ];

  return (
    <div className="py-12 md:py-18">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-10 md:mb-12">
            <h2 className="RoobertLight text-3xl md:text-4xl lg:text-5xl font-bold text-dark-blue mb-4">
              Our operating model
            </h2>
            <h3 className="RoobertMedium text-xl md:text-2xl font-bold text-dark-blue mb-4">
              Diamond-shaped, by design.
            </h3>
            <p className="text-lg text-dark-blue mb-8">
              We've built OBZ to deliver what modern enterprises need:
            </p>
          </div>

          {/* Three Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-24 mb-10">
            {principles.map((principle, index) => (
              <div key={index} className="relative bg-dark-blue text-white p-6 md:p-8">
                <h4 className="RoobertMedium text-lg md:text-xl font-bold mb-4">
                  {principle.title}:
                </h4>
                <p className="RoobertRegular text-sm md:text-base leading-relaxed">
                  {principle.description}
                </p>
                <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-16 h-16"></div>
              </div>
            ))}
          </div>

          {/* Conclusion */}
          <div>
            <p className="RoobertRegular text-lg text-dark-blue leading-relaxed">
              Our diamond delivery model puts experienced consultants and architects at the core, supported by automation below and analysts in training above. The result: better decisions, faster delivery, and lower cost-to-impact.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OperatingModel;
